import { render, staticRenderFns } from "./ViewerTemplate.vue?vue&type=template&id=725dae44"
import script from "./ViewerTemplate.vue?vue&type=script&lang=js"
export * from "./ViewerTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports